import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AppConfigView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import {
  invalidateAdminAppConfigAudit,
  invalidateAdminAppConfigs,
} from "@/lib/query/core/invalidation";

type UpdateAppConfigInput = {
  key: string;
  value: string;
};

export function useUpdateAppConfigMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ key, value }: UpdateAppConfigInput) =>
      apiJsonClient<AppConfigView>(endpoints.admin.appConfigByKey(key), {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ value }),
      }),
    onSuccess: async (_data, variables) => {
      await invalidateAdminAppConfigs(queryClient);
      await invalidateAdminAppConfigAudit(queryClient, variables.key);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
